import api from "./api";

class AliquotaManager {
    aliquote(config?: any) {
        return api.get(`/aliquote_iva`, config)
    }

    aliquota(id: number | string) {
        return api.get(`/aliquote_iva/${id}`)
    }

    list = this.aliquote
    retrieve = this.aliquota
}

const aliquotaManager = new AliquotaManager()

export default aliquotaManager
